/* eslint-disable  @typescript-eslint/no-non-null-assertion */
import * as React from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import classnames from 'classnames'
import { observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import NotationLayer from '../../components/common/notation-layer/NotationLayer'
import { Loader } from '@tfo/common'
import $http from '../../utils/$http'
import { useHistory } from 'react-router-dom'
import { ApprovalState, Language } from '../../models/Enums'

import Declined from './views/declined/Declined'
import Done from './views/done/Done'
import Withdrawn from './views/withdrawn/Withdrawn'
import Ongoing from './views/ongoing/Ongoing'
import ApprovalUnderReview from './views/approval-under-review/ApprovalUnderReview'
import AwaitResponse from './views/await-response/AwaitResponse'
import NoBackgroundCheck from './NoBackgroundCheck'

import { ApprovalUnderReviewViewModel, AwaitResponseViewModel, DeclinedViewModel, DoneViewModel, OngoingViewModel, OrderViewModel, ViewState, WithdrawnViewModel } from './ViewModels'

import './Individual.scss'

const Individual: React.FunctionComponent<
	WrappedComponentProps &
	RouteComponentProps> = () => {
		const history = useHistory()

		const [isLoading, setIsLoading] = React.useState<boolean>(false);
		const [orders, setOrders] = React.useState<Array<OrderViewModel>>(null);
		const [hasOrder, setHasOrder] = React.useState<boolean>(false)

		const userLanguage = localStorage.getItem('userLanguage') || 'Svenska' as Language		
		
		React.useEffect(() => {
			setIsLoading(true)
			$http.put(`update-user-language`, userLanguage, null, "text/plain")

			$http.get<Array<OrderViewModel>>(`order`)
				.then(o => {
					setOrders(o)

					setHasOrder(o.length > 0)
				})
				.catch(() => {
					console.error("failed fetching order")
				})
				.finally(() => {
					setIsLoading(false)
				})
		}, [userLanguage])

		React.useEffect(() => {
			if(!orders || orders.length !== 1) {
				return
			}
			const order = orders[0] as AwaitResponseViewModel
			if(order.viewState === ViewState.AwaitResponse && order.approval.canAccept) {
				history.push(`approval/${order.orderId}`)
			}
		}, [orders, history])

		const classes = classnames(
			'IndividualContainer',
			{ 'IndividualContainer--initialLoad': isLoading },
			{ 'IndividualContainer--loading': isLoading }
		)

		const getViewForModel = (order: OrderViewModel) => {
			switch (order.viewState) {
				case ViewState.AwaitResponse:
					return <AwaitResponse {...order as AwaitResponseViewModel} />
				case ViewState.Declined:
					return <Declined {...order as DeclinedViewModel} />
				case ViewState.Done:
					return <Done {...order as DoneViewModel}/>
				case ViewState.Ongoing:
					return <Ongoing {...order as OngoingViewModel} setIsLoading={setIsLoading} />
				case ViewState.Withdrawn:
					return <Withdrawn {...order as WithdrawnViewModel}/>
				case ViewState.ApprovalUnderReview:
					return <ApprovalUnderReview {...order as ApprovalUnderReviewViewModel } /> 
			}
		}

		return (
			<>
				{!isLoading &&
					<>
						{hasOrder ? (
							<div>
								{orders && orders.map(o => <div key={o.orderId} className={classes}>{getViewForModel(o)}</div>)}
							</div>
						) : (
							<NoBackgroundCheck />
						)}
					</>
				}
				<NotationLayer />
				{isLoading && <Loader />}
			</>
		)
	}

export default injectIntl(withRouter(observer(Individual)))
